import { Button, Card } from '@elva/ui';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

export function RouteErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  const is404 = isRouteErrorResponse(error) && error.status === 404;
  const title = is404 ? 'Page not found' : 'Something went wrong';
  const message = is404
    ? 'This page does not exist or may have been moved.'
    : isRouteErrorResponse(error)
      ? error.statusText || 'An unexpected error occurred.'
      : error instanceof Error
        ? error.message
        : 'An unexpected error occurred.';

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--cream-0)] px-6 py-10">
      <Card className="w-full max-w-md p-8">
        <h1 className="font-[var(--font-display)] text-[22px] font-semibold tracking-tight text-[var(--ink-0)]">
          {title}
        </h1>
        <p className="mt-2 text-[15px] text-[var(--ink-2)]">{message}</p>
        <div className="mt-6">
          <Button variant="primary" onClick={() => navigate('/')}>
            Back to dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}
